import { useNavigate } from 'react-router';
import { useStore } from '@/store';
import { EntryType } from '@morph-mapper/types';
import { match } from 'ts-pattern';
import { iteratorKeys } from '@/config';

/**
 * Supported entry types for shortcut routing to the iterator view.
 * Iterators currently cannot be other types (or they are hidden/predefined).
 */
const supportedTypes = [EntryType.Code, EntryType.Graph];

export const useItemRowIterator = (entryId: string) => {
  /* Global state */
  const [dependsOn, getKey, getType, templateId] = useStore(
    ({ entries: e, config: c }) => [
      e.getDependsOn(entryId),
      e.getKey,
      e.getType,
      c.getId(),
    ],
  );
  /* Hooks */
  const navigate = useNavigate();

  const findIterator = (): string | undefined => {
    for (const dependencyId of dependsOn) {
      const dependencyKey = getKey(dependencyId);

      if (iteratorKeys.includes(dependencyKey)) {
        return dependencyId;
      }
    }
  };

  const iteratorId = findIterator();

  const navigateToIterator = () => {
    if (!iteratorId) return;

    match(getType(iteratorId))
      .with(EntryType.Code, () => {
        navigate(`/${templateId}/entries/${iteratorId}/code`);
      })
      .with(EntryType.Graph, () => {
        navigate(`/${templateId}/entries/${iteratorId}/graph`);
      })
      .otherwise(() => {
        // Navigation to other types is not supported.
      });
  };

  const isRoutable =
    !!iteratorId && supportedTypes.includes(getType(iteratorId));

  return {
    hasIterator: !!iteratorId,
    isRoutable,
    openIterator: navigateToIterator,
  };
};
